import upgradeFormController from './controllers/upgrade.form.controller';

import upgradeFormComponent from './components/upgrade.form.component';

import upgradeService from './services/upgrade.service';

let upgradeModule = angular.module('spabooker.upgrade', [])
  .controller('upgradeFormController', upgradeFormController)

  .component('upgradeForm', upgradeFormComponent)

  .factory('upgradeService', upgradeService)
;

export default upgradeModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/upgrade/index.js